import { useState } from 'react';
import { ApiKeys } from '@/components/admin/api/api-keys';
import { useToast } from '@/hooks/use-toast';
import type { ApiKey } from '@/lib/types';

// Mock API keys data
const mockApiKeys: ApiKey[] = [
  {
    id: '1',
    name: 'Production API Key',
    key: 'fh_prod_123456789',
    status: 'active',
    createdAt: '2024-01-01T00:00:00Z',
    lastUsed: '2024-01-15T10:00:00Z',
  },
  {
    id: '2',
    name: 'Development API Key',
    key: 'fh_dev_987654321',
    status: 'active',
    createdAt: '2024-01-01T00:00:00Z',
    expiresAt: '2024-12-31T23:59:59Z',
  },
];

export function ApiKeysPage() {
  const [apiKeys] = useState(mockApiKeys);
  const { toast } = useToast();

  const handleCreateKey = () => {
    toast({
      title: 'Coming Soon',
      description: 'This feature will be available soon.',
    });
  };

  const handleRevokeKey = (keyId: string) => {
    toast({
      title: 'Coming Soon',
      description: 'This feature will be available soon.',
    });
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">API Keys</h1>
      <ApiKeys
        apiKeys={apiKeys}
        onCreateKey={handleCreateKey}
        onRevokeKey={handleRevokeKey}
      />
    </div>
  );
}